module.exports = __webpack_public_path__ + "img/Weapon_148.e78a82f8.png";